<template>
  <div v-if="loading" class="loader">
    <!-- <b-spinner
      variant="primary"
      type="grow"
      :label="`${this.$t('reports.loadingLabel')}...`"
    ></b-spinner> -->
    <idx-skeleton-chart type="pizza" class="mt-4" />
  </div>
  <div v-else class="col-12" style="align-items: center; text-align: center;">
    <div class="col-12" style="height: 65px;">
      <div class="main">
        <div class="filters">
          <b-button-group>
            <b-button
              class="buttons-filters"
              @click="type = 'byDevice'"
              v-bind:class="{
                active: type === 'byDevice',
              }"
              >Dispositivo</b-button
            >
            <b-button
              class="buttons-filters"
              @click="type = 'bySystem'"
              v-bind:class="{
                active: type === 'bySystem',
              }"
              >Sistema</b-button
            >
            <b-button
              class="buttons-filters"
              @click="type = 'byBrowser'"
              v-bind:class="{
                active: type === 'byBrowser',
              }"
              >Navegador</b-button
            >
          </b-button-group>
        </div>
      </div>
    </div>

    <template>
      <div
        v-if="type === 'byDevice'"
        class="col-lg-12 col-md-12 col-sm-12 card-devices"
      >
        <div class="align-card-center">
          <highcharts :options="chartOptionsDevice"></highcharts>
        </div>
      </div>

      <div
        v-if="type === 'bySystem'"
        class="col-lg-12 col-md-12 col-sm-12 card-devices"
        style="align-items: center; text-align: center;"
      >
        <div class="align-card-center">
          <highcharts :options="chartOptionsOS"></highcharts>
        </div>
      </div>

      <div
        v-if="type === 'byBrowser'"
        class="col-lg-12 col-md-12 col-sm-12 card-devices"
        style="align-items: center; text-align: center;"
      >
        <div class="align-card-center">
          <highcharts :options="chartOptionsBrowser"></highcharts>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import idxSkeletonChart from '@/components/molecules/idx-skeleton-chart';
import api from '../../../../../services/api';
import EventBus from '../../../../../eventBus';

export default {
  data: () => ({
    loading: true,
    chartOptionsDevice: {},
    chartOptionsBrowser: {},
    chartOptionsOS: {},
    browserSelector: null,
    osSelector: null,
    optionsBrowser: [],
    optionsSO: [],
    type: 'bySystem',
    height: 200,
    width: 200,
  }),

  props: ['dataGraph'],

  components: {
    idxSkeletonChart,
  },

  computed: {
    ...mapState('calendar', ['calendarDates']),
  },

  watch: {
    browserSelector: async function watchBrowserSelector(value) {
      const response = await api.get('/reports/device-panel', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.dataGraph.actionId
            ? this.dataGraph.actionId._id
            : null,
          period: this.dataGraph.period,
          ih1: this.dataGraph.ih1 && this.dataGraph.ih1.length > 0 ? this.dataGraph.ih1.map((item) => item._id): null,
          groupId: this.dataGraph.actionGroupId
            ? this.dataGraph.actionGroupId._id
            : null,
          metric: this.dataGraph.metric,
          indicator: this.dataGraph.indicator ? this.dataGraph.indicator : null,
          indicatorValue: this.dataGraph.valueIndicator,
          selected: value,
          _id: this.dataGraph._id,
        },
      });

      const mobile = response.data.dataMobile.mobile;
      const mobileQty = response.data.dataMobile.mobileQty;

      const desktop = response.data.dataDesktop.desktop;
      const desktopQty = response.data.dataDesktop.desktopQty;

      const tablet = response.data.dataTablet.tablet;
      const tabletQty = response.data.dataTablet.tabletQty;

      this.chartOptionsBrowser.series[0].data = [];

      if (value === 'mobile') {
        for (let i = 0; i < mobile.length; i += 1) {
          this.chartOptionsBrowser.series[0].data.push({
            name: mobile[i],
            y: mobileQty[i],
          });
        }
      }

      if (value === 'desktop') {
        for (let i = 0; i < desktop.length; i += 1) {
          this.chartOptionsBrowser.series[0].data.push({
            name: desktop[i],
            y: desktopQty[i],
          });
        }
      }

      if (value === 'tablet') {
        for (let i = 0; i < tablet.length; i += 1) {
          this.chartOptionsBrowser.series[0].data.push({
            name: tablet[i],
            y: tabletQty[i],
          });
        }
      }

      if (value === 'all') {
        this.getAllData();
      }
    },

    osSelector: async function watchBrowserSelector(value) {
      const response = await api.get('/reports/device-panel', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.dataGraph.actionId
            ? this.dataGraph.actionId._id
            : null,
          period: this.dataGraph.period,
          ih1:  this.dataGraph.ih1 && this.dataGraph.ih1.length > 0 ? this.dataGraph.ih1.map((item) => item._id): null,
          groupId: this.dataGraph.actionGroupId
            ? this.dataGraph.actionGroupId._id
            : null,
          metric: this.dataGraph.metric,
          indicator: this.dataGraph.indicator ? this.dataGraph.indicator : null,
          indicatorValue: this.dataGraph.valueIndicator,
          selected: value,
          _id: this.dataGraph._id,
        },
      });

      const mobile = response.data.dataMobile.mobile;
      const mobileQty = response.data.dataMobile.mobileQty;

      const desktop = response.data.dataDesktop.desktop;
      const desktopQty = response.data.dataDesktop.desktopQty;

      const tablet = response.data.dataTablet.tablet;
      const tabletQty = response.data.dataTablet.tabletQty;

      this.chartOptionsOS.series[0].data = [];

      if (value === 'mobile') {
        for (let i = 0; i < mobile.length; i += 1) {
          this.chartOptionsOS.series[0].data.push({
            name: mobile[i],
            y: mobileQty[i],
          });
        }
      }

      if (value === 'desktop') {
        for (let i = 0; i < desktop.length; i += 1) {
          this.chartOptionsOS.series[0].data.push({
            name: desktop[i],
            y: desktopQty[i],
          });
        }
      }

      if (value === 'tablet') {
        for (let i = 0; i < tablet.length; i += 1) {
          this.chartOptionsOS.series[0].data.push({
            name: tablet[i],
            y: tabletQty[i],
          });
        }
      }

      if (value === 'all') {
        this.getAllData();
      }
    },

    'dataGraph.layout.h': function watchHeightContent() {
        this.chartOptionsDevice.chart.width = this.dataGraph.layout.w * 70;
        this.chartOptionsDevice.chart.height = this.dataGraph.layout.h * 30;

        this.chartOptionsOS.chart.width = this.dataGraph.layout.w * 70;
        this.chartOptionsOS.chart.height = this.dataGraph.layout.h * 30;

        this.chartOptionsBrowser.chart.width = this.dataGraph.layout.w * 100;
        this.chartOptionsBrowser.chart.height = this.dataGraph.layout.h * 30;
    },
  },

  methods: {
      changeSize(){
        this.chartOptionsDevice.chart.width = this.dataGraph.layout.w * 70;
        this.chartOptionsDevice.chart.height = this.dataGraph.layout.h * 30;

        this.chartOptionsOS.chart.width = this.dataGraph.layout.w * 70;
        this.chartOptionsOS.chart.height = this.dataGraph.layout.h * 30;

        this.chartOptionsBrowser.chart.width = this.dataGraph.layout.w * 100;
        this.chartOptionsBrowser.chart.height = this.dataGraph.layout.h * 30;
    },

    async getAllData() {
      const response = await api.get('/reports/device-panel', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.dataGraph.actionId
            ? this.dataGraph.actionId._id
            : null,
          ih1: this.dataGraph.ih1 && this.dataGraph.ih1.length > 0 ? this.dataGraph.ih1.map((item) => item._id): null,
          groupId: this.dataGraph.actionGroupId
            ? this.dataGraph.actionGroupId._id
            : null,
          metric: this.dataGraph.metric,
          period: this.dataGraph.period,
          indicator: this.dataGraph.indicator ? this.dataGraph.indicator : null,
          indicatorValue: this.dataGraph.valueIndicator,
          _id: this.dataGraph._id,
        },
      });

      const devices = response.data.dataDevices.devices;
      const devicesQty = response.data.dataDevices.devicesQty;

      const browser = response.data.dataBrowser.browser;
      const browserQty = response.data.dataBrowser.browserQty;

      const operationalSystem = response.data.dataSO.operationalSystem;
      const operationalSystemQty = response.data.dataSO.operationalSystemQty;

      this.chartOptionsDevice.series[0].data = [];
      this.chartOptionsBrowser.series[0].data = [];
      this.chartOptionsOS.series[0].data = [];

      for (let i = 0; i < devices.length; i += 1) {
        this.chartOptionsDevice.series[0].data.push({
          name: devices[i],
          y: devicesQty[i],
        });
      }

      for (let i = 0; i < browser.length; i += 1) {
        this.chartOptionsBrowser.series[0].data.push({
          name: browser[i],
          y: browserQty[i],
        });
      }

      for (let i = 0; i < operationalSystem.length; i += 1) {
        this.chartOptionsOS.series[0].data.push({
          name: operationalSystem[i],
          y: operationalSystemQty[i],
        });
      }

      this.changeSize();
    },

    async getDeviceInfo() {
      this.loading = true;

      await this.getAllData();

      this.loading = false;
    },

    translateSelect() {
      this.optionsBrowser = [
        { value: null, text: this.$t('reports.deviceAnalysis.selectDevice') },
        { value: 'desktop', text: 'Desktop' },
        { value: 'mobile', text: 'Mobile' },
        { value: 'tablet', text: 'Tablet' },
        { value: 'all', text: this.$t('reports.deviceAnalysis.all') },
      ];

      this.optionsSO = [
        { value: null, text: this.$t('reports.deviceAnalysis.selectDevice') },
        { value: 'desktop', text: 'Desktop' },
        { value: 'mobile', text: 'Mobile' },
        { value: 'tablet', text: 'Tablet' },
        { value: 'all', text: this.$t('reports.deviceAnalysis.all') },
      ];
    },

    verifySize() {
      this.width = this.dataGraph.layout.w * 50;
      this.height = this.dataGraph.layout.h * 30;

      this.chartOptionsDevice = {
        title: {
          text: '',
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              // format: '<b>{point.name}</b>: {point.percentage:.1f}%',
              format: '{point.percentage:.1f}%',
            },
            showInLegend: true,
          },
        },
        colors: [
          '#22CD70',
          '#17a2b8',
          '#E84C3E',
          '#F3C102',
          '#ff6699',
          '#33cc33',
        ],
        series: [
          {
            innerSize: '50%',
            name: this.$t('reports.deviceAnalysis.qty'),
            data: [],
          },
        ],
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie',
          width: this.width,
          height: this.height,
          style: {
            fontFamily:
              '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue"',
            fontSize: '12px',
          },
        },
      };

      this.chartOptionsOS = {
        title: {
          text: '',
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              // format: '<b>{point.name}</b>: {point.percentage:.1f}%',
              format: '{point.percentage:.1f}%',
            },
            showInLegend: true,
          },
        },
        colors: [
          '#22CD70',
          '#17a2b8',
          '#E84C3E',
          '#F3C102',
          '#ff6699',
          '#33cc33',
        ],
        series: [
          {
            innerSize: '50%',
            name: this.$t('reports.deviceAnalysis.qty'),
            data: [],
          },
        ],
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie',
          width: this.width,
          height: this.height,
          style: {
            fontFamily:
              '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue"',
            fontSize: '12px',
          },
        },
      };

      this.chartOptionsBrowser = {
        title: {
          text: '',
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              // format: '<b>{point.name}</b>: {point.percentage:.1f}%',
              format: '{point.percentage:.1f}%',
            },
            showInLegend: true,
          },
        },
        colors: [
          '#22CD70',
          '#17a2b8',
          '#E84C3E',
          '#F3C102',
          '#ff6699',
          '#33cc33',
        ],
        series: [
          {
            innerSize: '50%',
            name: this.$t('reports.deviceAnalysis.qty'),
            data: [],
          },
        ],
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie',
          width: this.width,
          height: this.height,
          style: {
            fontFamily:
              '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue"',
            fontSize: '12px',
          },
        },
      };
    },
  },

  mounted() {
    EventBus.$on('changedLanguage', () => {
      this.translateSelect();
    });

    this.verifySize();
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.loading = true;

    this.verifySize();

    this.translateSelect();

    this.getDeviceInfo();
  },
};
</script>

<style scoped>
.main {
  display: flex;
  padding: 0;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.filters {
  background: #f0f6fb;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 20px;
  margin-top: 12px;
}

.buttons-filters {
  background: #f0f6fb;
  border-radius: 50rem;
  padding-left: 15px;
  padding-right: 15px;
  border: none;
  outline: none;
  font-size: 12px;
}

.buttons-filters.active {
  background: #fff !important;
  border-radius: 50rem !important;
  padding-left: 15px !important ;
  padding-right: 15px !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  font-weight: bold !important;
}
</style>

<style lang="scss">
.card-devices {
  padding: 0;
  margin-bottom: -16px;
  border: 8px solid #fff;
}

.align-card-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/device-analysis/panels/device-analysis.vue